import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class KpiRefreshService {
  shouldRefresh = new Subject();

  watchRefresh() {
    return this.shouldRefresh.asObservable();
  }

  refreshData() {
    this.shouldRefresh.next(true);
    this.shouldRefresh.next(null);
  }
}
